/**
 * Trial navigation helper. Entering a *just-created* trial org (seed or
 * erase-and-recreate) needs a clean context reload: the org list, membership
 * pointers and the active-org snapshot all have to re-resolve against a brand
 * new orgId. A full document load via `?org=` is the robust way to do that —
 * the app resolves the active org from the URL param (context_and_index.jsx /
 * org_url_manager.jsx). Isolated here so tests can mock the one navigation.
 */
export function enterTrialOrg(orgId) {
  if (!orgId) return;
  window.location.assign(`/?org=${orgId}`);
}
